import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';

export default function Navbar() {
  const [color, setColor] = useState(false)

  const changeColor = () => {
    if(window.scrollY >= 90){
      setColor(true)
    } else {
      setColor(false)
    }
  }
  window.addEventListener('scroll', changeColor)

  const handleOnClick = () => {
    const list = document.getElementById('list');
    if (list.classList.contains('hidden')) {
      list.classList.remove('hidden');
    } else {
      list.classList.add('hidden');
    }
  };
  return (
    <nav className={color ? 'flex fixed lg:bg-primary items-center flex-wrap z-50 w-screen top-0 uppercase bg-primary lg:pt-[2%] pt-[3%] lg:pb-[2%] pb-[3%] px-[3%]' : 'flex relative items-center flex-wrap z-10 uppercase lg:bg-transparent bg-primary lg:pt-[2%] pt-[3%] lg:pb-[2%] pb-[3%] px-[7%]'}>
      <button className="inline-flex lg:hidden ml-auto text-3xl" onClick={handleOnClick}>
        <FontAwesomeIcon icon={faBars} inverse />
      </button>
      <div className="hidden w-full lg:flex lg:flex-grow lg:w-auto" id="list">
        <ul className="flex lg:flex-row flex-col lg:items-center lg:ml-auto items-start">
          <li className="cursor-pointer lg:my-0 my-2">
            <a
              href="#home"
              className="lg:text-white text-white font-medium lg:px-5 lg:text-sm text-xs hover:underline duration-500">
              Home
            </a>
          </li>
          <li className="cursor-pointer lg:my-0 my-2">
            <a
              href="#about"
              className="lg:text-white text-white font-medium lg:px-5 lg:text-sm text-xs hover:underline duration-500">
              About
            </a>
          </li>
          <li className="cursor-pointer lg:my-0 my-2">
            <a
              href="#portfolio"
              className="lg:text-white text-white font-medium lg:px-5 lg:text-sm text-xs hover:underline duration-500">
              Portfolio
            </a>
          </li>
          <li className="cursor-pointer lg:my-0 my-2">
            <a
              href="#contact"
              className="lg:text-white text-white font-medium lg:px-5 lg:text-sm text-xs hover:underline duration-500">
              Contact
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}
